/**
 * 다회차 교육(교육 기간 지정)을 **화면에 띄울 것인가** — S1 게이트의 클라이언트 파생.
 *
 * ## ⚠️ 정본은 서버다
 * 판정의 정본은 `POST /reports/:id/tbm-distribution-setup`이다 —
 * `TbmDistributionSetupService.applySetup`이 `educationPeriod`가 하나라도 실리면 회사의
 * `category`/`agencyVerificationStatus`를 직접 읽어 아니면 403을 던진다(구
 * `tbm.service.distributeToEducators` 동형). 이 함수는 그 판정을 **대신하지 않는다**:
 * 어차피 거부될 입력칸을 보여 주지 않을 뿐이다. 그래서 이 술어가 틀려도 최악은
 * "낼 수 있는데 칸이 안 보인다"이지 **권한 우회가 아니다**.
 *
 * ## 왜 별도 모듈인가
 * ① 조회 응답(`GET .../tbm-distribution-setup`)이 이 가용 여부를 내리지 않아 클라이언트가
 *    멤버십에서 파생할 수밖에 없다(서버 응답 보완은 별도 판단 — W4b 보고).
 * ② 같은 축을 화면마다 인라인으로 적으면 한쪽만 고쳐져 갈린다 — 이름을 붙여 한 자리에 둔다.
 * ③ `lib/reports`에 두지 않는 이유: 그 모듈을 `vi.mock`하는 spec이 20개 넘어, 순수 술어를
 *    거기 넣으면 그 spec들이 `No "X" export is defined on the mock`으로 함께 죽는다
 *    (`memory/feedback-pure-predicate-must-not-live-in-a-vi-mocked-module`).
 */

/** 판정에 필요한 최소 형상만 받는다 — `Membership` 전체를 요구하면 호출부가 묶인다. */
export interface EducationPeriodEligibilityInput {
  company?: {
    category?: string | null;
    agencyVerificationStatus?: string | null;
  } | null;
}

/**
 * 다회차(교육 기간) 설정 입력을 노출할 수 있는가 — **검증된 안전관리전문기관만**.
 *
 * 두 축이 **모두** 필요하다: 기관 구분(`SAFETY_MANAGEMENT_AGENCY`)과 그 자격의 검증
 * 완료(`VERIFIED`). 한 축만 보면 검증 대기 중인 기관에도 칸이 열려 서버 403으로 튕긴다.
 *
 * @param membership 현재 조직 멤버십(로딩 중이면 null/undefined — 그 경우 감춘다)
 */
export function canConfigureEducationPeriod(
  membership: EducationPeriodEligibilityInput | null | undefined,
): boolean {
  return (
    membership?.company?.category === 'SAFETY_MANAGEMENT_AGENCY' &&
    membership?.company?.agencyVerificationStatus === 'VERIFIED'
  );
}
